import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import FolderOpenOutlinedIcon from "@material-ui/icons/FolderOpenOutlined";
import { Button } from "@material-ui/core";
import { ArrowBack, AttachFile } from "@material-ui/icons";
import NewCompaignForm from "./NewCompaignForm";
import { launchesActions } from "../../../../store/launches/launchesActions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { conversationAction } from "../../../../store/conversations/conversationAction";
import ConversationMediaUploadPopup from "../../../../components/common/Conversation/ConversationMediaUploadPopup";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}>
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: "100%",
  },
  tabsSelected: {
    //   background: 'red',
    //   border: 'none'
  },
  libraryList: {
    padding: "0",
    listStyle: "none",
    overflowY: "auto",
    maxHeight: "313px",
  },
  libraryListItems: {
    marginRight: "10px",
    fontSize: "30px",
  },
  libraryListItemsImage: {
    fontSize: "42px",
    display: "flex",
    marginRight: "10px",
    alignItems: "center",
  },
  listContainer: {
    borderBottom: "1px solid #f1f1f1",
    paddingBottom: "10px",
    display: "flex",
    alignItems: "center",
  },
  tabsNav: {
    boxShadow: "none",
  },
  selectBtn: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "25px",
    marginTop: "130px",
  },
  selectBtnWithExtraMargin: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "25px",
    marginTop: "30px",
  },
  dragAndDropFileWrap: {
    padding: "0px 20px 20px",
    height: "450px",
  },
  saveButton: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    margin: "15px",
  },
  email: {
    color: "#2D3339",
    fontSize: "22px",
    fontWeight: "700",
    marginBottom: "unset",
    marginLeft: "15px",
  },
  note: {
    color: "#eb5757",
    fontSize: "14px",
    fontWeight: 500,
    marginLeft: "15px",
    marginTop: "10px",
  },
  leadAttachmentIconSocial: {
    width: "0px",
    display: "flex",
    position: "relative",
    cursor: "pointer",
    color: "#333333",
    right: "5%",
    zIndex: 9,
  },
  leadAttachedFileUpload: {
    width: "auto",
    backgroundColor: "transparent",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#3699ff",
    float: "right",
    marginRight: "40px",
  },
}));

const CampaignModalTab = ({
  open,
  setOpen,
  setLoading,
  loadAllCampaigns,
  isSupportInbox,
}) => {
  const classes = useStyles();

  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

  const theme = useTheme();
  const {
    leadCampaignsData,
    endUserCampaignsData,
    businessCustomersCampaignsData,
  } = useSelector(state => state.LaunchesReducer);
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [endUserCampaign, setEndUserCampaign] = useState([]);
  const [businessCustomerCampaign, setBusinessCustomerCampaign] = useState([]);
  const [leadCampaign, setLeadCampaign] = useState([]);
  const [subject, setSubject] = useState("");
  const [model, setModel] = useState("");
  const [roomName, setRoomName] = useState("");
  const [isUpload, setIsUpload] = useState(false);
  const [uploadFile, setUploadFile] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileAttachment, setFileAttachments] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = index => {
    setValue(index);
  };

  function extractIds(arr) {
    return arr.map(item => item.id);
  }

  const onSubmitCampaign = () => {
    if (open?.platform === "Facebook") {
      submitFacebook();
    } else if (open?.platform === "Instagram") {
      submitInstagram();
    } else if (isSupportInbox) {
      submitSupportEmail();
    } else {
      setLoading(true);
      dispatch(
        launchesActions.onAddCampaign({
          subject: subject,
          body: model,
          groupType: "",
          type: open !== true ? "email" : value ? "message" : "email",
          isDeleted: true,
          businessUsers:
            open !== true
              ? []
              : businessCustomersCampaignsData?.length !==
                  businessCustomerCampaign?.length
                ? businessCustomerCampaign
                : ["All"],
          campaignEndUsers:
            open !== true
              ? []
              : endUserCampaignsData?.length !== endUserCampaign?.length
                ? endUserCampaign
                : ["All"],
          campaignLeadUsers:
            open !== true
              ? [open?.id]
              : leadCampaignsData?.length !== leadCampaign?.length
                ? leadCampaign
                : [-1],
          campaignProspects: [],
          attachments: fileAttachment,
        }),
      ).then(res => {
        if (res?.data?.success) {
          loadAllCampaigns();
          setOpen(false);
          toast.success(res?.data?.message);
        } else {
          toast.error(res?.data?.message);
          setOpen(true);
        }
        setLoading(false);
      });
    }
  };

  const uploadAttachments = async uploadingFile => {
    const attachments = [];
    const savedAttachments = await dispatch(
      conversationAction.onUploadFile(uploadFile),
    );
    if (savedAttachments?.responseCode === 1) {
      attachments.push({
        name: fileName,
        url: savedAttachments.responseData?.url,
      });
    }
    return attachments;
  };

  const submitSupportEmail = () => {
    setLoading(true);
    dispatch(
      conversationAction.onSaveSupportMsg({
        roomId: open.id,
        subject: subject,
        message: model,
        attachments: [],
      }),
    ).then(data => {
      if (
        data?.data?.responseCode === 1 &&
        data?.data?.responseMsg === "Success"
      ) {
        loadAllCampaigns();
        setOpen(false);
        toast.success("Email sent successfully");
      } else {
        toast.error(data?.data?.responseMsg);
        setOpen(true);
      }
      setLoading(false);
    });
  };

  const submitFacebook = async () => {
    let removeBRTag = model?.replace(/<br\s*\/?>/gi, "\n");
    let removedEntities = removeBRTag?.replace(/&nbsp;/g, " ");
    let content = removedEntities?.replace(/<[^>]*>/g, "").trim();
    let attachments = [];
    let attachmentType =
      uploadFile.length === 0
        ? ""
        : uploadFile[0].type.indexOf("image") > -1
          ? "image"
          : "file";
    setLoading(true);
    if (fileName && fileName !== "") {
      attachments = await uploadAttachments(uploadFile);
    }

    dispatch(
      conversationAction.onSendMessages({
        messageFrom: "Aquatic AV",
        messageTo: roomName,
        message: content ?? "",
        attachmentUrl: attachments.length ? attachments[0].url : "",
        attachmentType: attachmentType,
      }),
    ).then(res => {
      setLoading(false);
      if (res?.responseMsg === "Success") {
        loadAllCampaigns();
        setOpen(false);
      } else {
        toast.error(res?.responseMsg);
      }
    });
  };

  const submitInstagram = async () => {
    let removeBRTag = model?.replace(/<br\s*\/?>/gi, "\n");
    let removedEntities = removeBRTag?.replace(/&nbsp;/g, " ");
    let content = removedEntities?.replace(/<[^>]*>/g, "").trim();
    let attachments = [];
    let attachmentType =
      uploadFile.length === 0
        ? ""
        : uploadFile[0].type.indexOf("image") > -1
          ? "image"
          : "file";
    if (fileName && fileName !== "") {
      attachments = await uploadAttachments(uploadFile);
    }
    setLoading(true);
    dispatch(
      conversationAction.onSendInstaMessages({
        messageFrom: "Aquatic AV",
        messageTo: open?.roomId,
        message: content ?? "",
        attachmentUrl: attachments.length ? attachments[0].url : "",
        attachmentType: attachmentType,
      }),
    ).then(res => {
      setLoading(false);
      if (res?.responseMsg === "Success") {
        loadAllCampaigns();
        setOpen(false);
      } else {
        toast.error(res?.responseMsg);
      }
    });
  };

  useEffect(() => {
    if (open !== true) {
      setLeadCampaign([open?.id]);
    }
    if (open?.platform === "Facebook" || open?.platform === "Instagram") {
      onGetRoomByRoomId();
    }
  }, [open]);

  const onGetRoomByRoomId = () => {
    dispatch(conversationAction.onGetRoomByRId(open?.roomId)).then(data => {
      if (data?.responseMsg === "Success") {
        setRoomName(data?.responseData?.name);
      }
    });
  };

  return (
    <div className='marketingModal'>
      <div className={classes.root}>
        {open === true ? (
          <AppBar position='static' color='default' className={classes.tabsNav}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor='primary'
              textColor='primary'
              variant='fullWidth'
              aria-label='full width tabs example'>
              <Tab
                label='Email'
                {...a11yProps(0)}
                className={classes.tabsSelected}
              />
              {/* <Tab label='Message' {...a11yProps(1)} /> */}
            </Tabs>
          </AppBar>
        ) : null}
        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={value}
          onChangeIndex={handleChangeIndex}>
          <TabPanel
            value={value}
            index={0}
            dir={theme.direction}
            className='imageLoaderWrapper'>
            <NewCompaignForm
              open={open}
              endUserCampaign={endUserCampaign}
              setEndUserCampaign={setEndUserCampaign}
              businessCustomerCampaign={businessCustomerCampaign}
              setBusinessCustomerCampaign={setBusinessCustomerCampaign}
              leadCampaign={leadCampaign}
              setLeadCampaign={setLeadCampaign}
              model={model}
              setModel={setModel}
              subject={subject}
              setSubject={setSubject}
              isSupportInbox={isSupportInbox}
              attachments={fileAttachment}
              onAttachmentsChange={setFileAttachments}
              showAttachments={true}
            />
            {isUpload && (
              <ConversationMediaUploadPopup
                isMultiple={false}
                openPopup={isUpload}
                closePopup={() => setIsUpload(false)}
                fileName={fileName}
                setFileInfo={(name, file) => {
                  setFileName(name);
                  setUploadFile(file);
                }}
              />
            )}
          </TabPanel>

          <TabPanel value={value} index={1} dir={theme.direction}>
            Coming Soon
          </TabPanel>
        </SwipeableViews>
      </div>
      {/* <span className={classes.note}>
        Images are supported only. (JPEG, JPG, PNG and GIF)
      </span> */}
      <div className={classes.saveButton}>
        {(open?.platform === "Facebook" || open?.platform === "Instagram") && (
          <>
            <div className={classes.leadAttachedFileUpload}>{fileName}</div>
            <span
              className={classes.leadAttachmentIconSocial}
              onClick={() => {
                setIsUpload(true);
              }}>
              <AttachFile />
            </span>
          </>
        )}

        <Button
          color='primary'
          variant='contained'
          disabled={
            (open?.platform === "Facebook" && !fileName.length && !model) ||
            (open?.platform === "Instgram" && !fileName.length && !model) ||
            (open?.platform !== "Facebook" &&
              open?.platform !== "Instgram" &&
              subject.length === 0 &&
              !model) ||
            (open?.platform !== "Facebook" &&
              open?.platform !== "Instgram" &&
              endUserCampaign.length === 0 &&
              businessCustomerCampaign.length === 0 &&
              leadCampaign.length === 0)
              ? true
              : false
          }
          onClick={() => onSubmitCampaign()}>
          {open === true ? "Save" : "Send"}
        </Button>
      </div>
    </div>
  );
};

export default CampaignModalTab;
